// extracted by mini-css-extract-plugin
module.exports = {"persiePlayer":"VideoViewer_persiePlayer__28RaR","persieVideo":"VideoViewer_persieVideo__2Q1tQ","videoFill":"VideoViewer_videoFill__10_SJ","videoFit":"VideoViewer_videoFit__DjAd6"};